(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceAssignDetailController', GrievanceAssignDetailController);

    GrievanceAssignDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GrievanceAssign'];

    function GrievanceAssignDetailController($scope, $rootScope, $stateParams, previousState, entity, GrievanceAssign) {
        var vm = this;

        vm.grievanceAssign = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:grievanceAssignUpdate', function(event, result) {
            vm.grievanceAssign = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
